import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@redux-devtools/ui';
import { TiDownload } from 'react-icons/ti';
import { exportState } from '../../actions/index.js';
class ExportButton extends Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return (React.createElement(Button, { title: "Export to a file", onClick: this.props.exportState },
            React.createElement(TiDownload, null)));
    }
}
const actionCreators = {
    exportState,
};
export default connect(null, actionCreators)(ExportButton);
